import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BookingInfoService } from 'src/app/service/export-parts/booking-info.service';
import { Constants } from "src/app/constants";
import { Subject } from 'rxjs';
@Component({
  selector: 'app-add-load-type',
  templateUrl: './add-load-type.component.html',
  styleUrls: ['./add-load-type.component.scss']
})
export class AddLoadTypeComponent implements OnInit {
  playAudio: Subject<any> = new Subject();
  submitted = false;
  heading!: string;
  eventType: any;
  successMessage: any
  errorMessage: any;
  CommonMessage: any;
  fromDate: any;
  serviceProviderList: any = [];
  typeArray: any = [];
  dockCodeArray:any = []
  constructor(public dialogRef: MatDialogRef<AddLoadTypeComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any,
 private ngxUiLoaderService: NgxUiLoaderService,  private constants: Constants,
  private service: BookingInfoService, private fb: FormBuilder) { }

  addForm = this.fb.group({
    menuOption: ['', [Validators.required]],
    dockCode: ['', [Validators.required]],
    loadType: ['', [Validators.required]]
  })
  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType

    this.dockCodeArray = [{code:'DCD'},{code:'ECD'}]
    this.addForm.controls.dockCode.disable()
    if(this.eventType == 'ADD'){
      this.addForm.controls.dockCode.setValue(this.dataStore.dockCode)
      console.log("dock---code",this.dataStore.dockCode);
    }
    if(this.eventType == 'Edit'){
      this.addForm.controls.menuOption.setValue(this.dataStore.data.menu_options) 
      this.addForm.controls.dockCode.setValue(this.dataStore.data.dock_code)
      this.addForm.controls.loadType.setValue(this.dataStore.data.load_types) 
    }
  }

  onClick() {
    this.dialogRef.close({
      event: 'Noevent'
    })
  }
  get f(): { [key: string]: AbstractControl } {
    return this.addForm.controls;
  }

  

  submitForm() {
    this.submitted = true
    if (this.addForm.invalid) {
      return;
    }
    else{
      this.addorUpdateLoadTypes();
    }
  }
  validateMenuOption(event: any) {
    var charCode = event.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8)
      return true;
    else
      return false;
  }
  validateLoadType(event: any) {
    var charCode = event.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode >= 48 && charCode <= 57) || (charCode > 96 && charCode < 123) || charCode == 8)
      return true;
    else
      return false;
  }
  clearMsg() {
    this.successMessage = "";
    this.errorMessage = "";
    this.CommonMessage = "";
  }
  showError(msg: string) {
    this.playAudio.next('trouble');
    this.errorMessage = msg;
  }
  addorUpdateLoadTypes() {
    let updateData = {}
    let addUserObj = {
      "menu":this.addForm.controls.menuOption.value?.toUpperCase(),
      "dock":this.addForm.controls.dockCode.value,
      "load":this.addForm.controls.loadType.value?.toUpperCase()
      }
      let menuOptionValue = this.addForm.controls.menuOption.value;
      let loadTypeValue = this.addForm.controls.loadType.value;
      this.clearMsg();
      if(menuOptionValue?.substring(0, 1)?.toUpperCase() !== loadTypeValue?.substring(0, 1)?.toUpperCase()){
        this.errorMessage = 'Menu Option and Load type value not matching . '
        this.showError(this.errorMessage);
      }
      else{
      
    this.ngxUiLoaderService.start()
    if(this.eventType == 'ADD'){

      this.service.insertLoadType(addUserObj).subscribe({
        next: (res) => {
          this.ngxUiLoaderService.stop()
          console.log("--->error",res.ERROR);
          try {
            if (res.status == "SUCCESS") {
            // this.clearMsg();
              // this.successMessage = this.constants.APIDataSaved
              this.dialogRef.close(
                {
                  event: 'SaveEvent',
                  status: res.status,
                  eventData: this.constants.APIDataSaved
                }
              );
            }
            console.log("------>result",res);
            if(res.status == "FAILURE"){
              this.clearMsg();
              this.errorMessage = res.message
              this.showError(this.errorMessage);
            }
            console.log("--->error",res.ERROR);
            if(res.ERROR){
              this.clearMsg();
              this.errorMessage = res.ERROR
              this.showError(this.errorMessage);
            }
            if(res.status != "SUCCESS"){
              this.clearMsg();
              this.errorMessage = res.message
              this.showError(this.errorMessage);
            }
          }
          catch (error) {
          }
  
        },
        error: (err: any) => {
          this.clearMsg();
          this.errorMessage = this.constants.APIErrorMessage
          this.showError(this.errorMessage);
          this.ngxUiLoaderService.stop()
        }
      })
    }
    if(this.eventType == 'Edit'){
      updateData ={
        "menu":this.addForm.controls.menuOption.value?.toUpperCase(),
        "dock":this.addForm.controls.dockCode.value,
        "load":this.addForm.controls.loadType.value?.toUpperCase(),
        "menu1":this.dataStore.data.menu_options,
        "dock1":this.dataStore.data.dock_code,
        "load1":this.dataStore.data.load_types
        }
      this.service.updateLoadType(updateData).subscribe({
        next: (res) => {
          this.ngxUiLoaderService.stop()
          try {
            if (res.status == "SUCCESS") {
              // this.clearMsg();
              //  this.successMessage = this.constants.APIDataUpdated
              this.dialogRef.close(
                {
                  event: 'UpdateEvent',
                  status: res.status,
                  eventData: this.constants.APIDataUpdated
                }
              );
            }
            if(res.status == "FAILURE"){
              this.clearMsg();
              this.errorMessage = res.message
              this.showError(this.errorMessage);
            }
            if(res.ERROR){
              this.clearMsg();
              this.errorMessage = res.ERROR
              this.showError(this.errorMessage);
            }
            if(res.status != "SUCCESS"){
              this.clearMsg();
              this.errorMessage = res.message
              this.showError(this.errorMessage);
            }
          }
          catch (error) {
          }
  
        },
        error: (err: any) => {
          this.clearMsg();
          this.errorMessage = this.constants.APIErrorMessage
          this.ngxUiLoaderService.stop()
        }
      })
    }
  }

   }

  

}
